"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createPubNubClient = exports.ActivityFeedComponent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hoc = require("@apollo/client/react/hoc");
var _flowRight = _interopRequireDefault(require("lodash/flowRight"));
var _pubnub = _interopRequireDefault(require("pubnub"));
var _pubnubReact = require("pubnub-react");
var _LoadMoreSpinner = _interopRequireDefault(require("./LoadMoreSpinner"));
var _NotificationNumber = _interopRequireDefault(require("./NotificationNumber"));
var _styles = require("./styles");
var _getAppConfig = require("../../../../../../../constants/getAppConfig");
var _PersistedApollo = require("../../../../../../PersistedApollo");
var _ActivityFeedContext = require("../ActivityFeedContext");
var _HasUsedAlertsFeedMutation = require("../apollo/HasUsedAlertsFeedMutation");
var _PreferenceQuery = require("../apollo/PreferenceQuery");
var _isJson = require("../utils/isJson");
// istanbul ignore file

const createPubNubClient = _ref => {
  let {
    uuid,
    subscribeKey
  } = _ref;
  return new _pubnub.default({
    subscribeKey,
    userId: uuid,
    autoNetworkDetection: true,
    restore: true
  });
};
exports.createPubNubClient = createPubNubClient;
const ActivityFeedComponent = _ref2 => {
  var _getConfig$urls, _data$userPreferences2;
  let {
    isAfOpen,
    data,
    markAlertsFeedAsUsedMutation
  } = _ref2;
  const ref = (0, _react.useRef)((_getConfig$urls = (0, _getAppConfig.getConfig)().urls) === null || _getConfig$urls === void 0 ? void 0 : _getConfig$urls.activityFeedUrl);
  const iframeRef = (0, _react.useRef)();
  const [showSpinner, setShowSpinner] = (0, _react.useState)(true);
  const {
    hasEverClickedAlertsFeed,
    setAlertsFeedClicked
  } = (0, _react.useContext)(_ActivityFeedContext.AlertsFeedContext);
  (0, _react.useEffect)(() => {
    function onMessageReceive(event) {
      const domain = new URL(ref.current);
      if (event.origin === domain.origin && (0, _isJson.isJsonString)(event.data)) {
        const {
          type,
          data: messageData
        } = JSON.parse(event.data);
        if (type === 'AF_OPEN_URL_SELF') {
          window.open(messageData.url, '_self');
        }
      }
    }
    window.addEventListener('message', onMessageReceive);
    return () => {
      window.removeEventListener('message', onMessageReceive);
    };
  }, []);
  (0, _react.useEffect)(() => {
    var _data$userPreferences;
    if (!isAfOpen && !showSpinner) {
      setShowSpinner(true);
    }
    if (isAfOpen && !(data !== null && data !== void 0 && (_data$userPreferences = data.userPreferences) !== null && _data$userPreferences !== void 0 && _data$userPreferences.hasUsedAlertsFeed)) {
      setAlertsFeedClicked(true);
      markAlertsFeedAsUsedMutation();
    }
  }, [data === null || data === void 0 ? void 0 : (_data$userPreferences2 = data.userPreferences) === null || _data$userPreferences2 === void 0 ? void 0 : _data$userPreferences2.hasUsedAlertsFeed, isAfOpen, markAlertsFeedAsUsedMutation, setAlertsFeedClicked, showSpinner]);
  (0, _react.useEffect)(() => {
    var _data$userPreferences3;
    if (!data.loading && data.userPreferences && hasEverClickedAlertsFeed !== ((_data$userPreferences3 = data.userPreferences) === null || _data$userPreferences3 === void 0 ? void 0 : _data$userPreferences3.hasUsedAlertsFeed)) {
      var _data$userPreferences4;
      setAlertsFeedClicked((_data$userPreferences4 = data.userPreferences) === null || _data$userPreferences4 === void 0 ? void 0 : _data$userPreferences4.hasUsedAlertsFeed);
    }
  }, [data.loading, data.userPreferences, hasEverClickedAlertsFeed, setAlertsFeedClicked]);
  const hideSpinner = () => {
    setShowSpinner(false);
  };
  const onMessageReceive = () => {
    if (isAfOpen && iframeRef.current) {
      // @ts-ignore
      iframeRef.current.contentWindow.postMessage(JSON.stringify({
        type: 'AF_NEW_NOTIFICATION'
      }), ref.current);
    }
  };
  const onNumberDisplayed = () => {
    var _data$userPreferences5;
    if (data !== null && data !== void 0 && data.userPreferences && !((_data$userPreferences5 = data.userPreferences) !== null && _data$userPreferences5 !== void 0 && _data$userPreferences5.hasUsedAlertsFeed)) {
      markAlertsFeedAsUsedMutation();
    }
  };
  if (data.loading) return null;
  if (data.error || !data.userPreferences) return null;
  const {
    pubNub
  } = data === null || data === void 0 ? void 0 : data.userPreferences;
  const {
    subscribeKey,
    uuid
  } = pubNub || {};
  return /*#__PURE__*/_react.default.createElement(_pubnubReact.PubNubProvider, {
    client: createPubNubClient({
      subscribeKey,
      uuid
    })
  }, /*#__PURE__*/_react.default.createElement(_NotificationNumber.default, {
    openAf: isAfOpen,
    pubNubData: pubNub,
    onMessageReceive: onMessageReceive,
    onNumberDisplayed: onNumberDisplayed,
    setAlertsFeedClicked: setAlertsFeedClicked
  }), isAfOpen && /*#__PURE__*/_react.default.createElement(_styles.IFrameContainer, null, /*#__PURE__*/_react.default.createElement(_styles.IframeStyle, {
    ref: iframeRef,
    onLoad: hideSpinner,
    allowTransparency: "true",
    title: "AF",
    src: ref.current,
    width: showSpinner ? '0' : '100%',
    height: showSpinner ? '0' : '100%'
  }), showSpinner && /*#__PURE__*/_react.default.createElement(_LoadMoreSpinner.default, {
    "data-testid": "af-spinner"
  })));
};
exports.ActivityFeedComponent = ActivityFeedComponent;
var _default = exports.default = (0, _flowRight.default)((0, _hoc.graphql)(_PreferenceQuery.QUERY, {
  options: () => ({
    client: (0, _PersistedApollo.getFeedClient)(),
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-only'
  })
}), (0, _hoc.graphql)(_HasUsedAlertsFeedMutation.MUTATION, {
  name: 'markAlertsFeedAsUsedMutation',
  options: () => ({
    client: (0, _PersistedApollo.getFeedClient)(),
    update: proxy => {
      const data = proxy.readQuery({
        query: _PreferenceQuery.QUERY
      });
      proxy.writeQuery({
        query: _PreferenceQuery.QUERY,
        data: {
          ...data,
          userPreferences: {
            ...data.userPreferences,
            hasUsedAlertsFeed: true
          }
        }
      });
    }
  })
})
// @ts-ignore
)(ActivityFeedComponent);